
import { get_datiUserInfo } from "@/api/api.user.js";


const defaultState = () => {
  return {
    user: '',
    role: 0,
    group: '',
    descUser: '',
    menu: []
  }
}

const user = {
  namespaced: true,

  state: defaultState(),

  mutations: {
    SET_USER: (state, user) => {
      state.user = user.username
      state.role = user.roleId
      state.descUser = user.displayName
      state.menu = user.menu
    },

    RESET_USER: (state) => {
      Object.assign(state, defaultState())
    },


  },

  actions: {

    userInfo({
      commit,
      dispatch
    }) {

      return new Promise((resolve, reject) => {

        get_datiUserInfo().then(resp => {

          commit("SET_USER", resp.data)

          resolve(resp)

        }).catch(err => {
          reject(err)
        })
      })

    },



  },

  getters: {
    getRole: state => state.role,
    getGroup: state => state.group,
    getUser: state => state.user,
    getDescUser: state => state.descUser,
    getMenu: state => state.menu,
  }
}


export default user